

module.exports = __webpack_require__.stylable.create(
    "TipsBoxSelection2002974277",
    {"classes":{"root":"TipsBoxSelection2002974277__root","customAmountButton":"TipsBoxSelection2002974277__customAmountButton","option":"TipsBoxSelection2002974277__option"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    14,
    "TipsBoxSelection2002974277",
    null
);
